import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Badge, Button, Form, InputGroup, Spinner, Dropdown } from 'react-bootstrap';
import { getCourses, getCourseCategoriesApi } from '../../api/marketplace';
import heroImg from '../../assets/images/courses_hero_graphic.png';
import './courses.scss';

export const CoursesPageGuest = () => {
  const navigate = useNavigate();

  const [courses, setCourses] = useState([]);
  const [categories, setCategories] = useState([{ _id: '', name: 'All Courses', icon: '📚' }]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [sortBy, setSortBy] = useState('Most Popular');
  
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      // Try to fetch real categories
      try {
        const catRes = await getCourseCategoriesApi();
        if (catRes && catRes.data) {
          const apiCats = catRes.data.map(c => ({
            _id: c._id,
            name: c.name || c.title || 'Category',
            icon: '📚'
          }));
          setCategories([{ _id: '', name: 'All Courses', icon: '📚' }, ...apiCats]);
        }
      } catch (e) {
        console.warn('Guest categories fetch failed', e);
      }

      // Try to fetch real courses, fallback to mock
      try {
        const cRes = await getCourses();
        let list = Array.isArray(cRes.data) ? cRes.data : (cRes.data?.courses || []);
        if (list.length === 0) throw new Error('No courses');
        setCourses(list);
      } catch (e) {
        console.warn('Guest courses fetch failed, loading mock data', e);
        const { mockCoursesResponse } = await import('../../api/mockCourses');
        setCourses(mockCoursesResponse.data.courses || []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleLoginRedirect = () => {
    navigate('/login?redirect=/courses');
  };

  const handleCourseClick = (id) => {
    navigate(`/course-detail/${id}`);
  };

  const filteredCourses = courses.filter(c => {
    const titleMatch = (c.title || c.name || '').toLowerCase().includes(search.toLowerCase());
    return titleMatch;
  });

  return (
    <div className="courses-page guest-mode">
      <div className="courses-hero border-bottom">
        <Container fluid="xl" className="py-4">
          <Row className="align-items-center gx-3 gy-4">
            <Col lg={4} xl={3} md={12}>
              <div className="fs-4 fw-bold text-dark font-poppins mb-1 lh-sm">Upgrade Your Skills</div>
              <div className="fs-4 fw-bold text-purple font-poppins mb-2 lh-sm">Explore Top Courses</div>
              <p className="text-muted text-sm mb-0">Learn anytime, anywhere with expert-designed courses.</p>
              <Button variant="purple" className="mt-3 rounded-pill px-4" onClick={handleLoginRedirect}>Login to Join</Button>
            </Col>
            <Col lg={5} xl={6} md={12}>
              <InputGroup className="courses-hero-search rounded-3 shadow-sm bg-white border px-2">
                <Form.Control
                  placeholder="Search courses..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="border-0 shadow-none"
                />
              </InputGroup>
            </Col>
            <Col lg={3} xl={3} className="d-none d-lg-block text-center">
              <img src={heroImg} alt="Hero" className="img-fluid courses-hero-illustration" style={{ maxHeight: '130px' }} />
            </Col>
          </Row>
        </Container>
      </div>

      <Container fluid="xl" className="py-5">
        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <Row className="g-4 row-cols-1 row-cols-md-2 row-cols-xl-3">
            {filteredCourses.map(c => (
              <Col key={c.id || c._id}>
                <div className="course-item-card h-100 bg-white border rounded-3 shadow-sm overflow-hidden d-flex flex-column pointer transition-all" onClick={() => handleCourseClick(c.id || c._id)}>
                  <div className="card-image-wrapper position-relative overflow-hidden" style={{ height: '160px' }}>
                     <img src={c.image || c.coverImage || "https://images.unsplash.com/photo-1513258496099-48168024aec0?w=500&h=280&fit=crop"} alt={c.title} className="w-100 h-100 object-fit-cover" />
                  </div>
                  <div className="card-body p-3 flex-grow-1 d-flex flex-column justify-content-between">
                    <div>
                      <h6 className="fw-bold text-navy mb-1 text-truncate">{c.title || c.name}</h6>
                      <small className="text-muted">By {typeof c.instructor === 'object' ? (c.instructor.full_name || 'Yoospeak Instructor') : (c.instructor || 'Yoospeak Instructor')}</small>
                    </div>
                    <div className="mt-3 d-flex justify-content-between align-items-center">
                      <span className="fw-bold text-success">{c.price > 0 ? `$${c.price}` : 'Free'}</span>
                      <Button variant="outline-primary" size="sm" onClick={(e) => { e.stopPropagation(); handleLoginRedirect(); }}>Enroll</Button>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </div>
  );
};
